<template>
  <el-form
    :model="addForm"
    ref="addForm"
    label-width="120px"
    :hide-required-asterisk="false"
    class="form"
    id="add-program"
  >
    <el-row>
      <el-col :span="24">
        <el-form-item label="年份" prop="year">
          <el-date-picker
            style="width: 100%"
            v-model="addForm.year"
            type="year"
            placeholder="选择年"
            :picker-options="pickerOptions"
            @change="handleChengeYear"
          >
          </el-date-picker>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-form-item label="项目名称" prop="xmbh">
          <el-select
            v-model="addForm.xmbh"
            filterable
            default-first-option
            style="width: 100%"
            placeholder="请选择项目"
            @change="handleChengeXm"
          >
            <el-option
              v-for="item in xmList"
              :key="item.xmbh"
              :label="item.xmmc"
              :value="item.xmbh"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-form-item label="项目目标" prop="target">
          <el-input
            type="textarea"
            v-model="addForm.target"
            rows="2"
            placeholder="请输入项目目标"
            maxlength="200"
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-form-item label="最佳模型" prop="year">
          <el-cascader
            ref="cascaderModal"
            :options="modelList"
            style="width: 100%"
            v-model="addForm.modal"
            collapse-tags
            filterable
            clearable
            @visible-change="handleChangeModal"
            :props="{
              multiple: true,
              emitPath: false,
              value: 'id',
              label: 'title',
            }"
          >
            <template slot-scope="{ node, data }">
              <span>{{ data.title }}</span>
              <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
            </template>
          </el-cascader>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <el-table
          :data="list"
          fit
          v-loading="loading"
          highlight-current-row
          :default-sort="{ prop: 'date', order: 'descending' }"
          tooltip-effect="dark"
        >
          <el-table-column
            fixed
            label="操作"
            min-width="100px"
            align="center"
            class-name="small-padding fixed-width"
            :render-header="renderHeader"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="handleCopyRow(scope.row)"
                size="mini"
                >复制</el-button
              >
              <el-button
                type="text"
                @click="handleDelRow(scope.$index, list)"
                size="mini"
                >删除</el-button
              >
            </template>
          </el-table-column>

          <el-table-column
            label="目标分解"
            align="left"
            prop="target"
            min-width="200px"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.target"
                placeholder="目标分解"
              ></el-input>
            </template>
          </el-table-column>

          <el-table-column
            label="规划项名称"
            align="left"
            prop="name"
            min-width="150px"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.name"
                placeholder="规划项名称"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column
            label="负责人"
            align="left"
            prop="principal"
            min-width="280px"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <treeselect
                v-model="scope.row.principal"
                placeholder="请选择员工"
                :options="userList"
                :disable-branch-nodes="true"
                value-consists-of="LEAF_PRIORITY"
                no-results-text="未搜到任何结果"
                :clear-on-select="true"
                :normalizer="normalizer"
                style="width: 100%"
                size="small"
                :multiple="true"
                appendToBody
                :limit="1"
                :default-expand-level="1"
              />
              <!-- <el-cascader
                filterable
                :options="deptUser"
                v-model="scope.row.principal"
                :props="{
                  multiple: true,
                  emitPath: false,
                  value: 'id',
                  label: 'title',
                }"
                collapse-tags
                style="width: 100%"
                clearable
                :show-all-levels="false"
              >
              </el-cascader> -->
            </template>
          </el-table-column>
          <el-table-column
            label="起止日期"
            align="left"
            prop="time"
            min-width="375px"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <el-date-picker
                v-model="scope.row.time"
                type="daterange"
                align="right"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptionsTime"
              >
              </el-date-picker>
            </template>
          </el-table-column>

          <el-table-column
            label="关键动作"
            align="left"
            prop="link_point"
            min-width="200px"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <el-cascader
                :options="modelList"
                style="width: 100%"
                v-model="scope.row.link_point"
                collapse-tags
                filterable
                clearable
                :props="{
                  emitPath: false,
                  value: 'id',
                  label: 'title',
                }"
              >
                <template slot-scope="{ node, data }">
                  <span>{{ data.title }}</span>
                  <span v-if="!node.isLeaf">
                    ({{ data.children.length }})
                  </span>
                </template>
              </el-cascader>
            </template>
          </el-table-column>
          <template slot="empty">
            <div class="nodata">
              <img src="@/img/nodata.png" alt="" width="160" />
              <div>暂无数据</div>
            </div>
          </template>
        </el-table>
      </el-col>
      <el-col style="text-align: center; margin-top: 15px">
        <el-button type="primary" @click="handleInsert" :disabled="btnDisable"
          >保存规划</el-button
        >
        <!-- <el-button @click="handleClose">取消</el-button> -->
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { deepClone } from "@/utils/utils";
import moment from "moment";
import "moment/locale/zh-cn";
import { mapGetters } from "vuex";
import {
  getProgramModelList,
  getProjectsList,
  getProgramCount,
  loadKeepTouchUser,
  insertProgram,
} from "@/api/program.js";
export default {
  components: { Treeselect },
  computed: {
    ...mapGetters(["deptUser", "user", "question"]),
  },
  data() {
    return {
      normalizer(node) {
        return {
          id: node.id, // 键名转换，方法默认是label和children进行树状渲染
          label: node.title,
          children: node.children,
        };
      },
      list: [],
      loading: false,
      addForm: {
        year: new Date().getFullYear() + "",
        model: null,
        xmbh: null,
        target: null,
      },
      modelList: [],
      xmList: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getFullYear() > new Date().getFullYear();
        },
      },
      pickerOptionsTime: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7; // 不可选历史天、不可选当前天、可选未来天
        },
      },
      userList: [],
      btnDisable: true,
    };
  },
  created() {
    if (!this.deptUser || this.deptUser.length == 0) {
      this.$store.dispatch("common/getDeptUser");
    }
    getProjectsList().then((res) => {
      if (res.code == 0) {
        this.xmList = res.data;
      }
    });
    loadKeepTouchUser().then((res) => {
      if (res.code == 0) {
        // this.userList = res.data;
        for (const i in res.data) {
          const rowI = res.data[i].children;
          for (let j in rowI) {
            rowI[j].children = undefined;
            // const { children, ...newRow } = rowj;
            // res.data[i][j] = newRow;
          }
        }
        this.userList = res.data;
      }
    });
  },
  mounted() {},
  methods: {
    handleChengeYear() {
      this.isHasProject();
    },
    handleChengeXm(e) {
      this.isHasProject();
    },
    getModelList() {
      getProgramModelList({ xmbh: this.addForm.xmbh }).then((res) => {
        if (res.code == 0) {
          this.modelList = res.data;
        }
      });
    },

    isHasProject() {
      if (this.addForm.year && this.addForm.xmbh) {
        getProgramCount({
          year: moment(this.addForm.year).format("YYYY"),
          xmbh: this.addForm.xmbh,
        }).then((res) => {
          if (res.code == 0) {
            if (res.data != 0) {
              this.$message({
                type: "error",
                message: `当前项目${moment(this.addForm.year).format(
                  "YYYY"
                )}年已存在项目规划，暂时无法添加！`,
                duration: 1000,
              });
              this.btnDisable = true;

              // setTimeout(() => {
              //   this.addForm.xmbh = null;
              // }, 1000);
            } else {
              this.getModelList();
              this.btnDisable = false;
            }
          }
        });
      }
    },
    handleCopyRow(row) {
      if (!row) {
        this.list.push({
          target: null,
          name: null,
          principal: null,
          time: null,
          link_point: null,
        });
        return;
      }
      const newRow = deepClone(row);
      if (row.time && row.time.length > 0) {
        newRow.time = [
          moment(row.time[0]).format("YYYY-MM-DD"),
          moment(row.time[1]).format("YYYY-MM-DD"),
        ];
      }
      this.list.push(newRow);
    },

    handleDelRow(index, rows) {
      rows.splice(index, 1);
    },
    handleChangeModal(e) {
      if (!e) {
        //隐藏时触发
        let node = this.$refs["cascaderModal"].getCheckedNodes();

        if (node.length > 0) {
          //去重
          for (let i in node) {
            for (let j in this.list) {
              if (node[i].value == this.list[j].link_point) {
                node.splice(i, 1);
              }
            }
          }
        }
        if (node.length > 0) {
          this.loading = true;
          setTimeout(() => {
            this.loading = false;
          }, 1000);
          //表格批量新增
          for (let i in node) {
            this.list.push({
              target: null,
              name: node[i].label,
              principal: null,
              time: null,
              link_point: node[i].value,
            });
          }
        }
      }
    },
    handleInsert() {
      const { year, xmbh, target } = this.addForm;
      const list = deepClone(this.list);
      if (!target) {
        this.$message.error("请填写项目目标！");
        return;
      }
      if (this.list.length == 0) {
        this.$message.error("请填写规划！");
        return;
      }
      for (let i in list) {
        if (
          !(list[i].target && list[i].name && list[i].principal && list[i].time)
        ) {
          this.$message.error(
            "目标分解，规划项名称，负责人，起止日期都为必填项！"
          );
          return;
        } else {
          list[i].start_time = moment(this.list[i].time[0]).format("YYYYMMDD");
          list[i].end_time = moment(this.list[i].time[1]).format("YYYYMMDD");
          list[i].principal = list[i].principal.toString();
          Reflect.deleteProperty(list[i], "time");
        }
      }
      for (let i in list) {
        for (let j in list) {
          if (i !== j) {
            const isEqual = this.isObjectEqual(list[i], list[j]);
            if (isEqual) {
              this.$message.error("存在重复记录!");
              return;
            }
          }
        }
      }
      insertProgram({
        year: moment(year).format("YYYY"),
        xmbh,
        target,
        itemList: list,
      }).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    isObjectEqual(obj1, obj2) {
      let o1 = obj1 instanceof Object;
      let o2 = obj2 instanceof Object;
      if (!o1 || !o2) {
        // 如果不是对象 直接判断数据是否相等
        return obj1 === obj2;
      }
      // 判断对象的可枚举属性组成的数组长度
      if (Object.keys(obj1).length !== Object.keys(obj2).length) {
        return false;
      }
      for (let attr in obj1) {
        let a1 =
          Object.prototype.toString.call(obj1[attr]) == "[object Object]";
        let a2 =
          Object.prototype.toString.call(obj2[attr]) == "[object Object]";
        let arr1 =
          Object.prototype.toString.call(obj1[attr]) == "[object Array]";
        if (a1 && a2) {
          // 如果是对象继续判断
          return isObjectEqual(obj1[attr], obj2[attr]);
        } else if (arr1) {
          // 如果是对象 判断
          if (obj1[attr].toString() != obj2[attr].toString()) {
            return false;
          }
        } else if (obj1[attr] !== obj2[attr]) {
          // 不是对象的就判断数值是否相等
          return false;
        }
      }
      return true;
    },
    renderHeader() {
      return (
        <el-button size="small" on-click={() => this.handleCopyRow(null)}>
          操作<span class="el-icon-plus"></span>
        </el-button>
      );
    },
  },
};
</script>
<style lang="less" scoped>
.form {
  padding: 15px;
}
</style>